module.exports = __webpack_public_path__ + "static/heroloop-de27d5a6b4ce1dbe33b7d19211064875.mp4";